import React from "react";
import PropTypes from "prop-types";
import get from "lodash/get";
import set from "lodash/set";
import trim from "lodash/trim";
import replace from "lodash/replace";
import find from "lodash/find";
import orderBy from "lodash/orderBy";
import styled from "styled-components";
import moment from "../../../lib/moment.js";
import { Button } from "reactstrap";
import { Sticky } from "react-sticky";
import AlignedComponent from "./aligned-component";
import { AddProjectForecast } from "../form";
import * as CONSTANTS from "../constants";
import { FONTS } from "../../../constants";
import Select from "react-select";
import arrow_down from "../../../static/images/arrow-down-black.svg";
import arrow_up from "../../../static/images/arrow-up-black.svg";

class ProjectImplementation extends React.Component {
  static getDerivedStateFromProps(nextProps, prevState) {
    const tempState = { ...nextProps };   // <<< Fix T-018
    const prevEffSummary = get(prevState, "efficiencySummary", [])
    const nextEffSummary = get(nextProps, "efficiencySummary", [])
    if (
      !prevEffSummary.length && nextEffSummary.length > 0
      // JSON.stringify(get(nextProps, "base_project", [])) !== JSON.stringify(get(prevState, "base_project", [])) ||                    // <<< Fix T-018
      // JSON.stringify(get(nextProps, "projectAdditionalList", [])) !== JSON.stringify(get(prevState, "projectAdditionalList", [])) ||  // <<< Fix T-018
      // JSON.stringify(get(nextProps, "addition_projects", [])) !== JSON.stringify(get(prevState, "addition_projects", []))
    ) {
      const selectedAdditionProjects = get(nextProps, "addition_projects", []);  
      const baseProjects = get(nextProps, "base_project", []);
      const projectAdditionalList = orderBy(
        get(nextProps, "projectAdditionalList", []),
        (project) => {
          return selectedAdditionProjects.includes(get(project, "_id"));
        },
        "desc"
      );
      // <<<< BEGIN OF Fix T-018 >>>>
      const additional = projectAdditionalList.filter((project) => {
        return selectedAdditionProjects.includes(get(project, "_id"));
      });
      let nonChargeable = additional.filter((project) => {
        return CONSTANTS.non_chargeable.includes(get(project, "project_type"));
      });
      nonChargeable = orderBy(nonChargeable, "project_code", "asc");
      let chargeable = additional.filter((project) => {
        return CONSTANTS.forecast_type.includes(get(project, "project_type"));
      });
      // let nonChargeable = projectAdditionalList.filter((project) => {
      //   return CONSTANTS.non_chargeable.includes(get(project, "project_type"));
      // });
      // nonChargeable = orderBy(nonChargeable, "project_code", "asc");
      // let chargeable = projectAdditionalList.filter((project) => {
      //   return CONSTANTS.forecast_type.includes(get(project, "project_type"));
      // });
      // <<<< END OF Fix T-018 >>>>
      chargeable = orderBy(
        [...baseProjects, ...chargeable],
        "project_code",
        "asc"
      );
      const projects = [...chargeable, ...nonChargeable];
      const lobs = get(nextProps, "lobs", []);
      projects.map((p) => {
        const lob = find(lobs, {
          _id: get(p, "lob_id"),
        });
        p.lob_name = lob ? get(lob, "name", "-") : "-";
      });
      set(tempState, "projectAdditionalList", projectAdditionalList);                 // <<< Fix T-018
      set(tempState, "items", projects);
      set(tempState, "addition_projects", [...selectedAdditionProjects]);
      // set(tempState, "selectedProject", projects.map(p => get(p, "_id")));
      set(tempState, "selectedProject", [...selectedAdditionProjects]);
      set(tempState, "lob_list", get(nextProps, "lobs", [])
        .filter((l) => l.is_active)
        .map((l) => ({ value: l._id, label: l.name }))
      );
    }

    return tempState;
  }

  state = {
    sort_order: true,
    sort_column: 0,
    showAddProject: false,
    selectedRadioAddProject: 1,
    projectAdditionalList: [],
    selectedProject: [],
    efficiencySummary: [],
    lob_list: [],
    filter_lob: undefined,
    items: [],
  };

  handleCheckboxAddProject = (e) => {
    let { selectedProject } = this.state;
    const index = selectedProject.indexOf(e.target.id);
    if (index > -1) {
      selectedProject.splice(index, 1);
    } else selectedProject = [...this.state.selectedProject, e.target.id];
    this.setState({ selectedProject });
  };

  resetState = () => {
    this.setState({
      showAddProject: !this.state.showAddProject,
      selectedProject: [...get(this.props, "addition_projects")],
      selectedRadioAddProject: 1,
    });
  };

  clickAddProject = (type) => {
    switch (type) {
      case "cancel": {
        this.resetState();
        break;
      }
      case "add": {
        const { selectedProject } = this.state;
        const payload = { addition_projects: selectedProject };
        this.props.editEfficiency(get(this.props, "efficiencyID"), payload);
        this.resetState();
        break;
      }
      default:
        break;
    }
  };

  handleClickSort = (column) => {
    const listBase = [...get(this.state, "projectAdditionalList", [])];
    let { sort_order } = { ...this.state };

    if (column === this.state.sort_column) {
      sort_order = !this.state.sort_order;
      this.setState({
        sort_order: !this.state.sort_order,
      });
    } else {
      sort_order = false;
      this.setState({
        sort_order: false,
        sort_column: column,
      });
    }
    sort_order = sort_order ? "asc" : "desc";
    const order = ["project_code", "lob_name", "name", "sum_man_day"];
    const sortColumn = order.find((o) => o === column);
    const list = orderBy(
      listBase,
      (p) => {
        if (sortColumn === "sum_man_day") {
          return Number(replace(p.sum_man_day, ",", ""));
        }
        return trim(p[sortColumn]).toString();
      },
      sort_order
    );
    // const list = orderBy(listBase, sortColumn, sort_order);
    this.setState({ items: list });
  };

  // sortProject = (projectAdditionalList) => {
  //   const base_project = [...get(this.props, "base_project", [])];
  //   const addition_projects = [...get(this.props, "addition_projects", [])];
  //   const additional = projectAdditionalList.filter((project) => {
  //     return addition_projects.includes(get(project, "_id"));
  //   });
  //   let nonChargeable = additional.filter((project) => {
  //     return CONSTANTS.non_chargeable.includes(get(project, "project_type"));
  //   });
  //   nonChargeable = orderBy(nonChargeable, "project_code", "asc");
  //   let chargeable = additional.filter((project) => {
  //     return CONSTANTS.forecast_type.includes(get(project, "project_type"));
  //   });
  //   chargeable = orderBy(
  //     [...base_project, ...chargeable],
  //     "project_code",
  //     "asc"
  //   );
  //   return [...chargeable, ...nonChargeable].filter((p) =>
  //     this.state.filter_lob ? p.lob_id === this.state.filter_lob : true
  //   );
  // };

  renderHeader = () => {
    const efficiencySummary = get(this.props, "efficiencySummary", []);
    let prevYear = "";
    return (
      <Row>
        <LabelRow>
          <Row
            style={{
              width: get(this.props, "widthLeft") + 50,
              fontFamily: FONTS.GOTHAM_MEDIUM,
              borderBottom: "1px solid #CCCCCC",
              marginBottom: -1,
            }}
          >
            <CodeCol
              style={{ cursor: "pointer" }}
              onClick={() => this.handleClickSort("project_code")}
            >
              Proj. Code
              {"project_code" === this.state.sort_column &&
                (this.state.sort_order &&
                  "project_code" === this.state.sort_column ? (
                  <Icon src={arrow_up} alt="logo" />
                ) : (
                  <Icon src={arrow_down} alt="logo" />
                ))}
            </CodeCol>
            <LOBCol
              style={{ cursor: "pointer" }}
              onClick={() => this.handleClickSort("lob_name")}
            >
              LOB
              {"lob_name" === this.state.sort_column &&
                (this.state.sort_order &&
                  "lob_name" === this.state.sort_column ? (
                  <Icon src={arrow_up} alt="logo" />
                ) : (
                  <Icon src={arrow_down} alt="logo" />
                ))}
            </LOBCol>
            <NameCol
              style={{ cursor: "pointer" }}
              onClick={() => this.handleClickSort("name")}
            >
              Proj. Name
              {"name" === this.state.sort_column &&
                (this.state.sort_order && "name" === this.state.sort_column ? (
                  <Icon src={arrow_up} alt="logo" />
                ) : (
                  <Icon src={arrow_down} alt="logo" />
                ))}
            </NameCol>
            <ManDayCol
              style={{ cursor: "pointer" }}
              onClick={() => this.handleClickSort("sum_man_day")}
            >
              Man Days
              {"sum_man_day" === this.state.sort_column &&
                (this.state.sort_order &&
                  "sum_man_day" === this.state.sort_column ? (
                  <Icon src={arrow_up} alt="logo" />
                ) : (
                  <Icon src={arrow_down} alt="logo" />
                ))}
            </ManDayCol>
          </Row>
        </LabelRow>
        <Col>
          <YearRow>
            {efficiencySummary.map((month) => {
              const notEqual =
                moment(get(month, "month"), "YYYY-MM").year() !== prevYear;
              if (notEqual) {
                prevYear = moment(get(month, "month"), "YYYY-MM").year();
                return (
                  <YearCol
                    style={{
                      borderLeft: notEqual ? "1px solid #CCCCCC" : "",
                    }}
                  >
                    {moment(get(month, "month"), "YYYY-MM").year()}
                  </YearCol>
                );
              }
              return <YearCol />;
            })}
            <LabelRow>
              <Row
                style={{
                  width: 50,
                  height: 25,
                  borderLeft: "1px solid #CCCCCC",
                }}
              />
            </LabelRow>
          </YearRow>
          <MonthRow style={{ borderBottom: "none" }}>
            {efficiencySummary.map((month) => {
              return (
                <MonthCol style={{ paddingLeft: 10 }}>
                  {moment(get(month, "month"), "YYYY-MM").format("MMM")}
                </MonthCol>
              );
            })}
            <LabelRow>
              <Row
                style={{
                  width: 50,
                  height: 25,
                  borderLeft: "1px solid #CCCCCC",
                }}
              />
            </LabelRow>
          </MonthRow>
        </Col>
      </Row>
    );
  };

  renderDetail = () => {
    const efficiencySummary = get(this.props, "efficiencySummary");
    const addition_projects = [...get(this.props, "addition_projects", [])];
    return this.state.items
      .filter((p) =>
        this.state.filter_lob ? p.lob_id === this.state.filter_lob : true
      )
      .map((project) => {
        const isNonChargeable = CONSTANTS.non_chargeable.includes(
          get(project, "project_type")
        );
        let isAdditional = false;
        if (addition_projects.includes(get(project, "_id")))
          isAdditional = true;
        const start_date = get(project, "start_date");
        const end_date = get(project, "end_date");
        const project_code =
          !get(project, "project_code") || get(project, "project_code") === ""
            ? "Pre-sale"
            : get(project, "project_code");
        const project_man_day = get(project, "sum_man_day");
        const project_lob_name = get(project, "lob_name");
        return (
          <Col>
            <Row style={{ height: 50 }}>
              <LabelRow>
                <Row style={{ width: get(this.props, "widthLeft") + 50 }}>
                  <CodeCol>
                    <Text>{project_code}</Text>
                    <div className="tooltip">{project_code}</div>
                  </CodeCol>
                  <LOBCol>
                    <Text>{project_lob_name}</Text>
                    <div className="tooltip">{project_lob_name}</div>
                  </LOBCol>
                  <NameCol>
                    <Text style={{ width: "90%" }}>
                      {get(project, "name", "-")}
                    </Text>
                    <div className="tooltip">{get(project, "name", "-")}</div>
                  </NameCol>
                  <ManDayCol>
                    <Text style={{ width: "90%", textAlign: "right" }}>
                      {project_man_day}
                    </Text>
                    <div className="tooltip">{project_man_day}</div>
                  </ManDayCol>
                </Row>
              </LabelRow>
              <Row>
                {efficiencySummary.map((month, key) => {
                  const currMonth = moment(get(month, "month"));
                  if (currMonth.isBefore(moment(start_date), "month")) {
                    return (
                      <SummaryCol color={key === 6 ? "#EDEFF5" : "white"} />
                    );
                  } else if (
                    currMonth.isAfter(moment(start_date), "month") &&
                    currMonth.isBefore(moment(end_date), "month")
                  ) {
                    return (
                      <SummaryCol color={key === 6 ? "#EDEFF5" : "white"}>
                        <MiddleLegend
                          color={isNonChargeable ? "#9B59B6" : "#5CB85C"}
                        />
                      </SummaryCol>
                    );
                  } else if (
                    currMonth.isSame(moment(start_date), "month") &&
                    currMonth.isSame(moment(end_date), "month")
                  ) {
                    return (
                      <SummaryCol color={key === 6 ? "#EDEFF5" : "white"}>
                        <Legend
                          color={isNonChargeable ? "#9B59B6" : "#5CB85C"}
                        />
                      </SummaryCol>
                    );
                  } else if (currMonth.isSame(moment(start_date), "month")) {
                    return (
                      <SummaryCol color={key === 6 ? "#EDEFF5" : "white"}>
                        <HeadLegend
                          color={isNonChargeable ? "#9B59B6" : "#5CB85C"}
                        />
                      </SummaryCol>
                    );
                  } else if (currMonth.isSame(moment(end_date), "month")) {
                    return (
                      <SummaryCol color={key === 6 ? "#EDEFF5" : "white"}>
                        <TailLegend
                          color={isNonChargeable ? "#9B59B6" : "#5CB85C"}
                        />
                      </SummaryCol>
                    );
                  }
                  return <SummaryCol color={key === 6 ? "#EDEFF5" : "white"} />;
                })}
              </Row>
              <LabelRow>
                <Row style={{ width: 50, alignItems: "center" }}>
                  <AdditionalText>{isAdditional ? "Added" : ""}</AdditionalText>
                </Row>
              </LabelRow>
            </Row>
          </Col>
        );
      });
  };

  getOptions = (name) => {
    return this.state[name]
      .filter((l) => l !== "undefined" && l !== "-")
      .map((l) => {
        return { value: l, label: l };
      });
  };

  customStyles = {
    menu: (provided, state) => ({
      ...provided,
      zIndex: 999,
    }),
  };

  render() {
    const is_submited = get(this.props, "is_submited");
    const projectAdditionalList = get(this.state, "projectAdditionalList", []); // [...get(this.props, 'projectAdditionalList', [])]
    return (
      /* eslint no-underscore-dangle: 0 */
      <Wrapper>
        <AddProjectForecast
          open={this.state.showAddProject}
          toggle={(type) => this.clickAddProject(type)}
          projectAdditionalList={projectAdditionalList}
          selectedProject={this.state.selectedProject}
          selectedRadioAddProject={this.state.selectedRadioAddProject}
          handleCheckboxAddProject={this.handleCheckboxAddProject}
          clickAddProject={this.clickAddProject}
          clickRadioAddProject={(radio) =>
            this.setState({ selectedRadioAddProject: radio })
          }
          handleClickAll={(filteredProjects) => {
            const array_project_id = [...this.state.selectedProject];
            filteredProjects.forEach((r) => {
              if (this.state.selectedProject.indexOf(r._id) < 0)
                array_project_id.push(r._id);
            });
            this.setState({ selectedProject: array_project_id });
          }}
          handleClickNone={(filteredProjects) => {
            const array_project_id = [...this.state.selectedProject];
            filteredProjects.forEach((r) => {
              const index = array_project_id.indexOf(r._id);
              if (index >= 0) array_project_id.splice(index, 1);
            });
            this.setState({ selectedProject: array_project_id });
          }}
        />
        <div style={{ width: "200px" }}>
          <Select
            styles={this.customStyles}
            isClearable={true}
            placeholder="Filter LOB"
            options={this.state.lob_list}
            onChange={(option) =>
              this.setState({
                filter_lob: option ? option.value : undefined,
              })
            }
          ></Select>
        </div>
        <Header>
          <span>Project Implementation Plan</span>
          {!is_submited && (
            <CustomButton
              onClick={() =>
                this.setState({ showAddProject: !this.state.showAddProject })
              }
            >
              Forecast Project
            </CustomButton>
          )}
        </Header>
        <AlignedComponent padding={0}>
          <TableWrapper style={{ height: "100%" }}>
            <Sticky relative={true}>
              {({ style }) => <Div style={style}>{this.renderHeader()}</Div>}
            </Sticky>
            {this.renderDetail()}
          </TableWrapper>
        </AlignedComponent>
      </Wrapper>
    );
  }
}

ProjectImplementation.propTypes = {
  editEfficiency: PropTypes.func,
};
ProjectImplementation.defaultProps = {
  editEfficiency: () => { },
};

export default ProjectImplementation;

const Icon = styled.img`
  height: 10px;
  margin-left: 5%;
  cursor: pointer;
`;

const Div = styled.div`
  height: 50px;
  top: 210px !important;
  z-index: 2 !important;
  background: #eeeeee;
`;
const Wrapper = styled.div`
  margin-top: 10px;
  font-family: ${FONTS.GOTHAM};
  font-size: ${FONTS.SMALL_SIZE};
  margin-bottom: 10px;
  margin-left: 10px;
  margin-right: 10px;
  -moz-box-shadow: 1px 2px 4px rgba(0, 0, 0, 0.16);
  -webkit-box-shadow: 1px 2px 4px rgba(0, 0, 0, 0.16);
  box-shadow: 1px 2px 4px rgba(0, 0, 0, 0.16);

  .container {
    height: calc(100vh - 250px);
    background: #eeeeee;
    max-width: 100%;
  }
  .gap.tall {
    height: 100%;
  }
  .container.relative {
    overflow-y: auto;
    margin: 0px;
    padding: 0px;
  }
`;
const Row = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  position: relative;
`;
const Col = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;
const Header = styled.div`
  height: 50px;
  width: 100%;
  background: #404040;
  color: white;
  font-family: ${FONTS.GOTHAM_MEDIUM};
  font-size: ${FONTS.SMALL_SIZE};
  display: flex;
  justify-content: space-between;
  padding-left: 10px;
  align-items: center;
`;
const TableWrapper = styled.div`
  width: 100%;
  background: #ffffff;
`;
const WrapperRow = styled.div`
  display: flex;
  flex-direction: row;
  height: 100%;
  width: 100%;
`;
const MonthRow = styled(WrapperRow)`
  height: 25px;
  color: black;
  justify-content: space-around;
  align-items: center;
`;
const YearRow = styled(MonthRow)`
  background-color: white;
`;
const MonthCol = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  background-color: #ededed;
  border-left: 1px solid #cccccc;
  :last-child {
    border-right: 1px solid #cccccc;
  }
`;
const YearCol = styled(MonthCol)`
  border-left: none;
  border-top: 1px solid #cccccc;
  background-color: white;
  padding-left: 10px;
  padding-right: 10px;
`;
const CodeCol = styled(YearCol)`
  border-left: none;
  border-top: 1px solid #cccccc;
  background-color: white;
  width: 30%;

  :last-child {
    border-right: none;
  }

  span {
    white-space: nowrap;
    width: 90%;
    overflow: hidden;
    text-overflow: ellipsis;
    position: relative;
    pointer-events: none;
  }

  span:after {
    content: "";
    display: block;
    position: absolute;
    top: 0;
    right: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
    pointer-events: initial;
  }

  .tooltip {
    width: 50%;
    max-width: 200px;
    font-size: 12px;
    top: 30px;
    background-color: #fff;
    padding: 5px;
    -webkit-box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.3);
    transition: opacity 1s ease;
    opacity: 0;
    visibility: hidden;
  }

  span:hover + .tooltip,
  .tooltip:hover {
    transition: opacity 0s ease;
    transition-delay: 1s;
    opacity: 1;
    visibility: visible;
  }
`;
const LOBCol = styled(CodeCol)`
  width: 15%;
`;
const ManDayCol = styled(CodeCol)`
  width: 25%;
`;
const NameCol = styled(CodeCol)`
  width: 35%;
`;
const Text = styled.span`
  width: 50%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
const AdditionalText = styled.span`
  width: 100%;
  font-family: ${FONTS.GOTHAM};
  font-size: ${FONTS.SMALL_SIZE};
  text-align: center;
`;
const SummaryCol = styled(MonthCol)`
  background-color: ${(props) => props.color};
`;
const LabelRow = styled.div`
  background-color: white;
  display: flex;
  flex-direction: row;
`;
const Legend = styled.div`
  width: 100%;
  height: 50%;
  border-radius: 10px 10px 10px 10px;
  background-color: ${(props) => props.color};
  text-align: center;
`;
const HeadLegend = styled.div`
  width: 100%;
  height: 50%;
  border-radius: 10px 0px 0px 10px;
  background-color: ${(props) => props.color};
  text-align: center;
`;
const MiddleLegend = styled.div`
  width: 100%;
  height: 50%;
  background-color: ${(props) => props.color};
  text-align: center;
`;
const TailLegend = styled.div`
  width: 100%;
  height: 50%;
  border-radius: 0px 10px 10px 0px;
  background-color: ${(props) => props.color};
  text-align: center;
`;
const CustomButton = styled(Button)`
  font-family: ${FONTS.GOTHAM_MEDIUM};
  font-size: ${FONTS.SMALL_SIZE};
  height: 30px;
  width: 150px;
  margin-left: 5px;
  margin-right: 5px;
  text-align: center;
  background-color: #d44b49;
`;



// WEBPACK FOOTER //
// ./src/components/efficiency-resource/components/project-implementation-plan.js